import { render, staticRenderFns } from "./RelocationList.vue?vue&type=template&id=6ad950a9"
import script from "./RelocationList.vue?vue&type=script&lang=js"
export * from "./RelocationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports